const community = {
  events: {
    hero: {
      eyebrow: "Join us",
      title: "Donation Events",
      subtitle:
        "Upcoming pravachans, festivals and donation drives at Jivandhara.",
    },
    tabs: {
      upcoming: "Upcoming Events",
      past: "Past Events",
    },
    categories: {
      all: "All Events",
      dharma: "Dharma & Pravachan",
      health: "Health Camps",
      cultural: "Cultural & Festivals",
      daan: "Daan Abhiyans",
    },
    searchPlaceholder: "Search events or venue...",
    loading: "Loading events…",
    empty: "No events found.",
    badge: "Community Event",
    viewDetails: "View Details",
    rsvpBtn: "Register / RSVP",
    raised: "Raised {{amount}}",
    goal: "Goal {{amount}}",
    funded: "{{pct}}% funded",
    remaining: "Remaining:",
    donateNow: "Donate Now",
    enquire: "Enquire",
    detailModal: {
      shareEvent: "Share Event",
      copied: "Link Copied!",
      agenda: "Event Schedule & Agenda",
      getDirections: "Get Directions",
    },
    rsvpModal: {
      title: "Register for Event",
      subtitle: "Confirm your attendance to reserve passes",
      successTitle: "Registration Confirmed!",
      passNotice: "Your digital entry pass has been generated",
      fullName: "Full Name",
      phone: "Mobile Number",
      email: "Email Address",
      guests: "Total Attendees",
      specialNeeds: "Special Assistance / Notes",
      submit: "Confirm Registration",
      downloadPass: "Download Entry Pass",
    },
  },
  news: {
    hero: {
      eyebrow: "Latest",
      title: "News & Updates",
      subtitle: "Stories, milestones and announcements from Jivandhara.",
    },
    empty: "No posts yet.",
  },
  gallery: {
    hero: {
      eyebrow: "Moments",
      title: "Gallery",
      subtitle: "Glimpses of life, seva and celebrations at Jivandhara.",
    },
    loading: "Loading…",
    sampleNote: "Showing sample photos — real gallery coming soon.",
    categories: {
      festivalCelebrations: "Festival and Celebrations",
      gaushala: "Gaushala",
      derasar: "Deraser",
      outdoorActivities: "Outdoor Activities",
    },
    empty: "No photos in this category yet.",
  },
  jainPanchang: {
    hero: {
      eyebrow: "Spiritual calendar",
      title: "Jain Panchang",
      subtitle:
        "Explore tithis, festivals, vows and sacred observances on the Jain lunar calendar.",
    },
    empty: "No panchang entries for this month yet.",
    highlights: {
      loading: "Loading today's panchang…",
    },
    today: {
      eyebrow: "Today's Auspicious Date",
      jainMonth: "Jain Lunar Month",
      paksha: "Paksha (Fortnight)",
      currentTithi: "Current Tithi",
      significance: "Today's Significance",
      viewDetails: "View full details",
      donateToday: "Donate Today",
    },
    upcoming: {
      title: "Upcoming Highlighted Jain Tithis",
      details: "Details",
      donate: "Donate",
    },
    calendar: {
      today: "Today",
      weekdays: "SUN,MON,TUE,WED,THU,FRI,SAT",
      loading: "Loading calendar…",
      vow: "Vow",
    },
    modal: {
      subtitle: "Scripture & Astro Details",
      lunarCalendar: "Jain Lunar Calendar",
      monthPaksha: "Month",
      significance: "Significance",
      recommended: "Recommended Vows & Observances",
      goBack: "Go Back",
      donate: "Donate Now",
    },
  },
  feedback: {
    hero: {
      eyebrow: "We're listening",
      title: "Feedback",
      subtitle: "Your voice helps us serve better.",
    },
    form: {
      fullName: "Full Name",
      mobile: "Mobile",
      email: "Email",
      type: "Type",
      rating: "Rating",
      message: "Message",
      submit: "Submit Feedback",
      submitting: "Submitting...",
    },
    types: {
      suggestion: "Suggestion",
      complaint: "Complaint",
      appreciation: "Appreciation",
      other: "Other",
    },
    toast: {
      success: "Thank you for your feedback!",
      error: "Could not submit feedback. Please try again.",
    },
  },
};

export default community;
